// extracted by mini-css-extract-plugin
module.exports = {"overlay-modal":"modal_overlay-modal__2O-34","modal":"modal_modal__2dWce","close":"modal_close__9l4zr"};